import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { IPracticeQuestions } from 'src/app/Models/QuestionMaster';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import { QuestionManagementService as QuestionPreviewService } from 'src/app/Services/question-management/question-management.service';
import { IProcessedPracticeQuestion, QuestionManagementService as QuestionPracticeService } from 'src/app/Services/question-management.service';
import { ConstantVars } from 'src/app/utils/constants/constants';
@Component({
  selector: 'app-assign-practice-question-study-material',
  templateUrl: './assign-practice-question-study-material.component.html',
  styleUrls: ['./assign-practice-question-study-material.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AssignPracticeQuestionStudyMaterialComponent implements OnInit {
  @Input() studyMaterial:any
  practiceQuestion: IProcessedPracticeQuestion[] = [];
  currentPreviewQuestion: IProcessedPracticeQuestion | null = null;
  previewdetail: any;
  Questionpreviewpopupflag: boolean = false;
  selectedQuestionById: any;
  subjectById: any;
  Answerflag: string = 'R';
  RightAnswer1: any;
  Screenname: any;
  EditQuestionBodyPopup: boolean = false;
  EditAnswerChoicePopup: boolean = false;
  AnswerChoiceNotePopup1: boolean = false;
  SolutionHintPopup: boolean = false;
  constructor(
    public activeModal: NgbActiveModal,
    public service: QuestionPracticeService,
    private previewService: QuestionPreviewService,
    private sanitizer: DomSanitizer,
    private toastr: ToastrService,

  ) { }

  ngOnInit(): void {

    this.getPracticeQuestionForStudymaterial()
  }

  getPracticeQuestionForStudymaterial(): void{
    const selectedQuestionMap = new Map<string, boolean>(
      (this.practiceQuestion || []).map((q) => [String(q.Question_ID), !!q.isChecked])
    );

    const payload ={
      StudyMaterialID: this.studyMaterial?.Study_Material_Id
    }
     this.service.getPraticeQuestion(payload).subscribe({
      next:(res: IProcessedPracticeQuestion[])=>{
        this.practiceQuestion = (res || []).map((q: IProcessedPracticeQuestion) => ({
          ...q,
          isChecked: selectedQuestionMap.get(String(q.Question_ID)) ?? !!q.isChecked,
        }));
      },
      error:(err)=>{

      }
     })
  }

  onCheckboxChange(question: any, index: number) {
    console.log(`Checkbox ${index} changed: `, question.isChecked);
    // You can collect selected questions here
  }

  openQuestionPreview(question: IProcessedPracticeQuestion) {
    this.currentPreviewQuestion = question;
    this.previewdetail = this.buildPreviewDetail(question);

    // app-question-preview depends on QuestionByIDlist in this service.
    this.previewService.QuestionByIDlist = [
      {
        Question_ID: question?.Question_ID,
        Question_Status_Type_Code: question?.Question_Status_Type_Code || question?.Question_Status_Type_Name || 'WIP',
      },
    ];

    this.Questionpreviewpopupflag = true;
  }

  isQuestionApproved(question?: IProcessedPracticeQuestion | null): boolean {
    if (!question) return false;
    const statusCode = (question.Question_Status_Type_Code || '').toLowerCase();
    const statusName = (question.Question_Status_Type_Name || '').toLowerCase();
    return statusCode === 'approved' || statusCode === 'appr' || statusName === 'approved';
  }

  private buildPreviewDetail(question: IProcessedPracticeQuestion): any {
    const rightAnswer = (question?.AllAnswers || []).find(
      (answer: any) => answer.Right_Answer_Ind === 'Y'
    );
    const wrongAnswers = (question?.AllAnswers || []).filter(
      (answer: any) => answer.Right_Answer_Ind !== 'Y'
    );

    return {
      safehtmlStr: this.sanitizer.bypassSecurityTrustHtml(
        question?.Question_Text || ''
      ),
      RightAnswer11: rightAnswer?.Answer_Choice_Text
        ? this.sanitizer.bypassSecurityTrustHtml(rightAnswer.Answer_Choice_Text)
        : '',
      RightAnswer1: rightAnswer || null,
      WrongAnswer11: wrongAnswers[0]?.Answer_Choice_Text
        ? this.sanitizer.bypassSecurityTrustHtml(wrongAnswers[0].Answer_Choice_Text)
        : '',
      WrongAnswer22: wrongAnswers[1]?.Answer_Choice_Text
        ? this.sanitizer.bypassSecurityTrustHtml(wrongAnswers[1].Answer_Choice_Text)
        : '',
      WrongAnswer33: wrongAnswers[2]?.Answer_Choice_Text
        ? this.sanitizer.bypassSecurityTrustHtml(wrongAnswers[2].Answer_Choice_Text)
        : '',
      WrongAnswer44: wrongAnswers[3]?.Answer_Choice_Text
        ? this.sanitizer.bypassSecurityTrustHtml(wrongAnswers[3].Answer_Choice_Text)
        : '',
      WrongAnswer55: wrongAnswers[4]?.Answer_Choice_Text
        ? this.sanitizer.bypassSecurityTrustHtml(wrongAnswers[4].Answer_Choice_Text)
        : '',
      WrongAnswer66: wrongAnswers[5]?.Answer_Choice_Text
        ? this.sanitizer.bypassSecurityTrustHtml(wrongAnswers[5].Answer_Choice_Text)
        : '',
      WrongAnswer77: wrongAnswers[6]?.Answer_Choice_Text
        ? this.sanitizer.bypassSecurityTrustHtml(wrongAnswers[6].Answer_Choice_Text)
        : '',
    };
  }

  ReturnQuestionpreview() {
    this.Questionpreviewpopupflag = false;
  }

  EmitpreviewtoQuestion() {
    this.ReturnQuestionpreview();
    this.closeAllChildPopups();

    const questionId =
      this.currentPreviewQuestion?.Question_ID ||
      this.previewService.QuestionByIDlist?.[0]?.Question_ID;

    if (!questionId) {
      this.toastr.error('Question details not available.');
      return;
    }

    // app-question-body-add-edit needs the full question record (not the
    // lightweight preview projection) plus the owning subject, otherwise
    // Save fails on missing fields.
    this.previewService.GetQuestionByID({ QuestionID: questionId }).subscribe({
      next: (res: any) => {
        const questionRecord = res?.result;
        if (!questionRecord?.length) {
          this.toastr.error('Unable to load question details.');
          return;
        }

        const subjectId =
          questionRecord[0]?.Subject_Id ?? questionRecord[0]?.Subject_ID;

        this.previewService
          .getsubjectById({ CurrentNodeSubjectID: Number(subjectId) })
          .subscribe({
            next: (subject: any) => {
              this.subjectById = subject;
              this.selectedQuestionById = questionRecord;
              this.previewService.QuestionByIDlist = questionRecord;
              this.EditQuestionBodyPopup = true;
            },
            error: (err) => {
              console.log(err);
              this.toastr.error('Unable to load subject details.');
            },
          });
      },
      error: (err) => {
        console.log(err);
        this.toastr.error('Unable to load question details.');
      },
    });
  }

  EmitpreviewtoAnswerChoice() {
    this.ReturnQuestionpreview();
    this.closeAllChildPopups();
    const selectedAnswer = this.buildSelectedAnswerContext();
    if (!selectedAnswer?.Question_ID) {
      this.toastr.error('Question details not available.');
      return;
    }

    this.selectedQuestionById = selectedAnswer;
    this.Answerflag = selectedAnswer?.Right_Answer_Ind === 'Y' ? 'R' : 'W';
    this.RightAnswer1 = selectedAnswer;
    this.EditAnswerChoicePopup = true;
  }

  EmitpreviewtoAnswerChoiceNote() {
    this.ReturnQuestionpreview();
    this.closeAllChildPopups();
    const selectedAnswer = this.buildSelectedAnswerContext();
    if (!selectedAnswer?.Question_ID || !selectedAnswer?.Answer_Choice_ID) {
      this.toastr.warning('No answer choice found for opening Answer Note.');
      return;
    }

    this.selectedQuestionById = selectedAnswer;
    this.AnswerChoiceNotePopup1 = true;
  }

  EmitpreviewtoSolutionHint() {
    this.ReturnQuestionpreview();
    this.closeAllChildPopups();
    const selectedAnswer = this.buildSelectedAnswerContext();
    if (!selectedAnswer?.Question_ID || !selectedAnswer?.Answer_Choice_ID) {
      this.toastr.warning('No answer choice found for opening Solution Hint.');
      return;
    }

    this.selectedQuestionById = selectedAnswer;
    this.SolutionHintPopup = true;
  }

  EditQuestionBodyclose() {
    this.EditQuestionBodyPopup = false;
    this.refreshQuestionsAfterEdit();
  }

  REdirecttoRightAnswer(data: any) {
    if (data && typeof data === 'object' && data.QuestionById) {
      this.selectedQuestionById = data.QuestionById;
      this.Answerflag = data.Answerflag1 || 'R';
    } else {
      const selectedAnswer = this.buildSelectedAnswerContext();
      this.selectedQuestionById = selectedAnswer;
      this.Answerflag = selectedAnswer?.Right_Answer_Ind === 'Y' ? 'R' : 'W';
      this.RightAnswer1 = selectedAnswer;
    }
    this.EditQuestionBodyPopup = false;
    this.EditAnswerChoicePopup = true;
  }

  EditAnswerchoiceclose() {
    this.EditAnswerChoicePopup = false;
    this.refreshQuestionsAfterEdit();
  }

  EditAnswerChoiceNoteBody(data: any) {
    if (data && typeof data === 'object' && data.Question_ID && data.Answer_Choice_ID) {
      this.selectedQuestionById = data;
    } else {
      this.selectedQuestionById = data?.QuestionById || this.buildSelectedAnswerContext();
    }
    this.EditAnswerChoicePopup = false;
    this.AnswerChoiceNotePopup1 = true;
  }

  EditSolutionHint1(data: any) {
    if (data && typeof data === 'object' && data.Question_ID && data.Answer_Choice_ID) {
      this.selectedQuestionById = data;
    } else {
      this.selectedQuestionById = data?.QuestionById || this.buildSelectedAnswerContext();
    }
    this.EditAnswerChoicePopup = false;
    this.SolutionHintPopup = true;
  }

  EditAnswerchoiceNoteclose() {
    this.AnswerChoiceNotePopup1 = false;
    this.refreshQuestionsAfterEdit();
  }

  EditAnswerchoiceNoteclose11() {
    this.SolutionHintPopup = false;
    this.refreshQuestionsAfterEdit();
  }

  REdirecttoRightAnswerfromnote(data: any) {
    this.Screenname = data;
    if (this.Screenname === 'app-answer-choice-note') {
      this.AnswerChoiceNotePopup1 = false;
    } else if (this.Screenname === 'app-answer-choice-solution-hint') {
      this.SolutionHintPopup = false;
    }
    const selectedAnswer = this.buildSelectedAnswerContext();
    if (!selectedAnswer?.Question_ID) {
      this.toastr.error('Question details not available.');
      return;
    }

    this.selectedQuestionById = selectedAnswer;
    this.Answerflag = selectedAnswer?.Right_Answer_Ind === 'Y' ? 'R' : 'W';
    this.RightAnswer1 = selectedAnswer;
    this.EditAnswerChoicePopup = true;
  }

  Returnpreview() {
    this.closeAllChildPopups();
    this.refreshQuestionsAfterEdit();
    this.Questionpreviewpopupflag = true;
  }

  returnfromanswer(data?: any) {
    this.closeAllChildPopups();
    this.EmitpreviewtoQuestion();
  }

  REdirectPreview(data: any) {
    if (data?.safehtmlStr) {
      this.previewdetail = this.previewdetail || {};
      this.previewdetail.safehtmlStr = data.safehtmlStr;
    }
    this.closeAllChildPopups();
    this.Questionpreviewpopupflag = true;
  }

  AnswerRedirectPreview(data: any) {
    if (data?.safehtmlStr && data?.Indicator !== undefined) {
      this.previewdetail = this.previewdetail || {};
      const idx = data.Indicator;
      if (idx === 0) this.previewdetail.RightAnswer11 = data.safehtmlStr;
      else if (idx === 1) this.previewdetail.WrongAnswer11 = data.safehtmlStr;
      else if (idx === 2) this.previewdetail.WrongAnswer22 = data.safehtmlStr;
      else if (idx === 3) this.previewdetail.WrongAnswer33 = data.safehtmlStr;
      else if (idx === 4) this.previewdetail.WrongAnswer44 = data.safehtmlStr;
      else if (idx === 5) this.previewdetail.WrongAnswer55 = data.safehtmlStr;
      else if (idx === 6) this.previewdetail.WrongAnswer66 = data.safehtmlStr;
      else if (idx === 7) this.previewdetail.WrongAnswer77 = data.safehtmlStr;
    }
    this.closeAllChildPopups();
    this.Questionpreviewpopupflag = true;
  }

  Questionrefreshpreview(data: any) {
    if (data?.safehtmlStr) {
      this.previewdetail = this.previewdetail || {};
      this.previewdetail.safehtmlStr = data.safehtmlStr;
    }
  }

  RefreshPreviewAnswer(data: any) {
    if (data?.safehtmlStr && data?.Indicator !== undefined) {
      this.previewdetail = this.previewdetail || {};
      const idx = data.Indicator;
      if (idx === 0) this.previewdetail.RightAnswer11 = data.safehtmlStr;
      else if (idx === 1) this.previewdetail.WrongAnswer11 = data.safehtmlStr;
      else if (idx === 2) this.previewdetail.WrongAnswer22 = data.safehtmlStr;
      else if (idx === 3) this.previewdetail.WrongAnswer33 = data.safehtmlStr;
      else if (idx === 4) this.previewdetail.WrongAnswer44 = data.safehtmlStr;
      else if (idx === 5) this.previewdetail.WrongAnswer55 = data.safehtmlStr;
      else if (idx === 6) this.previewdetail.WrongAnswer66 = data.safehtmlStr;
      else if (idx === 7) this.previewdetail.WrongAnswer77 = data.safehtmlStr;
    }
  }

  private closeAllChildPopups() {
    this.EditQuestionBodyPopup = false;
    this.EditAnswerChoicePopup = false;
    this.AnswerChoiceNotePopup1 = false;
    this.SolutionHintPopup = false;
  }

  private buildSelectedAnswerContext(): any {
    const questionId = this.currentPreviewQuestion?.Question_ID || this.previewService.QuestionByIDlist?.[0]?.Question_ID;
    const rightAnswer = (this.currentPreviewQuestion?.AllAnswers || []).find((a: any) => a.Right_Answer_Ind === 'Y');
    const fallbackAnswer = (this.currentPreviewQuestion?.AllAnswers || [])[0];
    const selectedAnswer = rightAnswer || fallbackAnswer;

    return {
      Question_ID: questionId,
      Question_Status_ID: this.previewService.QuestionByIDlist?.[0]?.Question_Status_ID,
      Answer_Choice_ID: selectedAnswer?.Answer_Choice_ID || null,
      Right_Answer_Ind: selectedAnswer?.Right_Answer_Ind || null,
    };
  }

  private refreshQuestionsAfterEdit() {
    this.getPracticeQuestionForStudymaterial();

    if (!this.currentPreviewQuestion) {
      return;
    }

    this.service.getPraticeQuestion({
      StudyMaterialID: this.studyMaterial?.Study_Material_Id,
    }).subscribe({
      next: (res) => {
        const updatedQuestion = (res || []).find(
          (q: IProcessedPracticeQuestion) =>
            String(q.Question_ID) === String(this.currentPreviewQuestion?.Question_ID)
        );

        if (updatedQuestion) {
          this.currentPreviewQuestion = updatedQuestion;
          this.previewdetail = this.buildPreviewDetail(updatedQuestion);
        }
      },
    });
  }


  onSave(){
    if(!this.practiceQuestion.filter((ele)=>ele.isChecked).map((e)=> e.Question_ID).length){
      this.toastr.error('Please select a Question', '', {
        timeOut: ConstantVars.ToastErrorTimeout,
      });
      return
    }

    const payload = {
      StudyMaterialID: this.studyMaterial?.Study_Material_Id,
      UDTStudyMaterialPracticeQuestionSelected: this.practiceQuestion.filter((ele)=>ele.isChecked).map((e)=> e.Question_ID)
    }
    this.service.InsertOrUpdateStudyMaterialPracticeQuestion$(payload).subscribe({
      next:(res)=>{
        this.toastr.success('Pratcie Question Saved ', '', {
          timeOut: ConstantVars.ToastSucessTimeout,
        });
      },
      error:(err)=>{
        console.log(err);

      }
    })

  }

  onCross() {
    this.activeModal.close(false);
  }

}
